// Reflect the Exorbyte search flyout state on the body element.
const SEARCH_OPEN_CLASS = 'search-is-open';
const SCROLLBAR_WIDTH_PROPERTY = '--scrollbar-width';

export default function initSearchFlyoutState() {
  const observer = new MutationObserver(() => {
    const flyout = document.querySelector('.exsg_box');
    const isOpen = Boolean(flyout) && getComputedStyle(flyout).display === 'block';

    document.body.classList.toggle(SEARCH_OPEN_CLASS, isOpen);

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    if (isOpen && scrollbarWidth > 0) {
      document.body.style.setProperty(SCROLLBAR_WIDTH_PROPERTY, `${scrollbarWidth}px`);
    } else {
      document.body.style.removeProperty(SCROLLBAR_WIDTH_PROPERTY);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  });
}
